import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { CURRENT_POLICY } from '@prcins/constants';
import { IPolicy } from '@prcins/utils';
import { PolicyProviderService } from 'libs/policy/src/lib/services/policy-provider.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'prcins-premium-entry',
  templateUrl: './premium-entry.component.html',
  styleUrls: ['./premium-entry.component.css']
})
export class PremiumEntryComponent implements OnChanges {
  premiumDetails$
  @Input() policy: IPolicy;

  constructor(private policyService: PolicyProviderService) { }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.premiumDetails$ = this.policyService.getPolicyPremiumDetails(sessionStorage.getItem(CURRENT_POLICY)).pipe(tap(response => {
      let sortedData: any[] = response['premiumEntries'];
      sortedData = sortedData.filter(entry => entry.premiumAmt != 0);
      sortedData.sort((a, b) => {
        return b.premiumAmt - a.premiumAmt;
      });

      response['premiumEntries'] = sortedData;
    }));
  }

}
